import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-grid-system';
import ConfigManager from '../../common/configManager/configManager';
import Label from '../shared/Label';
import TeamLabel from '../shared/TeamLabel';
import * as status from '../../constants';
import { MatchViewWrapper, MatchViewTeam, PreMatchWrapper } from './styles';
import MatchRowScorers from '../shared/MatchRowScorers';
import DateLabel from '../shared/DateLabel';
import SingleMatchResult from '../shared/SingleMatchResult';
import Timing from '../TimeResults/Timing';

const imagesURL = ConfigManager.getFootballTeams('med');


class MatchViewGazzanet extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  setPhaseLabel = () => {
    const { dictionary, currentMatch } = this.props;
    let label = '';
    if (currentMatch.get('competitionName') === 'Champions League Qualifying' || currentMatch.get('competitionName') === 'UEFA Europa League Qualifying') {
      label = 'Preliminari';
    } else if ((currentMatch.get('competitionName') === 'Champions League' || currentMatch.get('competitionName') === 'UEFA Europa League')
      && currentMatch.get('competitionRound') !== 'Round') {
      label = `${currentMatch.get('competitionDay')}${dictionary.competitionTable.dayA}`;
    } else if ((currentMatch.get('competitionId') === '259') && currentMatch.get('competitionRound') === 'Round') {
      label = `${currentMatch.get('competitionDay')}${dictionary.competitionTable.dayA}`;
    } else {
      label = `${dictionary.competitionTable.roundName[currentMatch.get('competitionRound')]}`;
    }
    return label;
  };

   isLive = matchStatus => (matchStatus === status.LIVE_STATUS);


  switchContent = (matchStatus) => {
    const { currentMatch, dictionary } = this.props;
    switch (matchStatus) {
      case status.PREMATCH_STATUS:
        return (
          <PreMatchWrapper>
            <DateLabel
              date={currentMatch.get('date')}
              color="white"
              size={0.8}
              margin="5px 0px 8px 0px"
              lightSkin
            />
            <Timing
              timing={currentMatch.get('timing')}
              isLive={this.isLive(currentMatch.get('status'))}
              date={currentMatch.get('date')}
              dictionary={dictionary}
              lightSkin
            />
            <Label
              label={currentMatch.get('venue')}
              margin="15px 0px"
              size={0.7}
              width="70%"
              textAlignment="center"
              color="black"
              block
            />
          </PreMatchWrapper>
        );
      case status.FULL_STATUS:
        return (
          <PreMatchWrapper>
            <SingleMatchResult
              statusTiming={matchStatus}
              homeScore={currentMatch.getIn(['homeTeam', 'score'])
                ? currentMatch.getIn(['homeTeam', 'score']) : '0'}
              awayScore={currentMatch.getIn(['awayTeam', 'score'])
                ? currentMatch.getIn(['awayTeam', 'score']) : '0'}
            />
            <Timing
              margin="14px 0px 0px"
              timing={currentMatch.get('timing')}
              isLive={this.isLive(currentMatch.get('status'))}
              date={currentMatch.get('date')}
              dictionary={dictionary}
              lightSkin
            />
          </PreMatchWrapper>
        );
      case status.LIVE_STATUS:
        return (
          <PreMatchWrapper>
            <SingleMatchResult
              statusTiming={matchStatus}
              homeScore={currentMatch.getIn(['homeTeam', 'score'])
                ? currentMatch.getIn(['homeTeam', 'score']) : '0'}
              awayScore={currentMatch.getIn(['awayTeam', 'score'])
                ? currentMatch.getIn(['awayTeam', 'score']) : '0'}
            />
            <Timing
              margin="14px 0px 0px"
              timing={currentMatch.get('timing')}
              isLive={this.isLive(currentMatch.get('status'))}
              date={currentMatch.get('date')}
              dictionary={dictionary}
              lightSkin
            />
          </PreMatchWrapper>
        );
      default:
        return (
          <div />
        );
    }
  };

  render() {
    const {
      currentMatch,
      isMobile,
      dictionary,
      competitionId,
    } = this.props;
    const teamHome = currentMatch ? currentMatch.getIn(['homeTeam', 'teamName']) : '';
    const teamAway = currentMatch ? currentMatch.getIn(['awayTeam', 'teamName']) : '';
    return (
      <MatchViewWrapper>
        <div>
          <Col
            md={12}
            sm={12}
            style={{
                //padding: '0px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
          >
            {currentMatch.get('competitionType') === 'CUP' ?
              <Label
                preLabel={`${dictionary.competitionTable.competitionName[competitionId]}: `}
                label={this.setPhaseLabel()}
                color="black"
                size={1}
                margin="10px 0px 4px 0px"
                textAlignment="center"
                height={16}
                width={300}
              />
                :
              <Label
                preLabel={`${dictionary.competitionTable.competitionName[competitionId]}: `}
                label={currentMatch.get('competitionDay') ? `${currentMatch.get('competitionDay')}${dictionary.competitionTable.dayA}` : ''}
                color="black"
                size={1}
                margin="10px 0px 4px 0px"
                textAlignment="center"
                height={16}
                width={300}
              />
              }
          </Col>
        </div>
        <div
          style={{
              //padding: '5px 0px 0px 0px',
              margin: '0px',
              display: 'flex',
            }}
        >
          <Col
            md={3.5}
            sm={4}
            xs={4}
            style={{
                //padding: '0px',
                overflow: 'visible',
                alignItems: 'center',
                justifyContent: 'center',
              }}
          >
            <MatchViewTeam
              toLeft
            >
              <TeamLabel
                color="black"
                size={isMobile ? 14 : 18}
                label={teamHome}
                image={`${imagesURL}${currentMatch.getIn(['homeTeam', 'teamId'])}.png`}
                isMatchPage
                isAColumn={isMobile}
                font="narrowRegular"
                height={isMobile ? '50px' : '60px'}
                alignment="center"
                marginLeft={!isMobile ? 0.7 : 0}
                marginWrapper={!isMobile ? '5px 0px 5px 30%' : '5px 0px 5px 10%'}
                marginTop={!isMobile ? 5 : 10}
              />
            </MatchViewTeam>
          </Col>
          <Col
            md={5}
            sm={4}
            xs={4}
            style={{
                //padding: '0px',
                overflow: 'visible',
              }}
          >
            {this.switchContent(currentMatch.get('status'))}
          </Col>
          <Col
            md={3.5}
            sm={3.5}
            xs={3.5}
            style={{
               // padding: '0px',
                overflow: 'visible',
              }}
          >
            <MatchViewTeam>
              <TeamLabel
                color="black"
                size={isMobile ? 14 : 18}
                label={teamAway}
                image={`${imagesURL}${currentMatch.getIn(['awayTeam', 'teamId'])}.png`}
                isMatchPage
                isMatchPageInverse={!isMobile}
                isAColumn={isMobile}
                font="narrowRegular"
                height={isMobile ? '50px' : '60px'}
                alignment="center"
                marginRight={!isMobile ? 0.7 : 0}
                marginTop={!isMobile ? 5 : 10}
                marginWrapper={!isMobile ? '5px 30% 5px 0px' : '5px 10% 5px 0px'}
              />
            </MatchViewTeam>
          </Col>
        </div>
        <div
          style={{
              padding: '10px 0px 5px 0px',
              margin: '0px',
              display: 'flex',
              overflow: 'hidden',
            }}
        >
          <Col
            md={3.5}
            sm={4.5}
            xs={4.5}
            style={{
                padding: '0px 0px 0px 8px',
                overflow: 'visible',
                alignItems: 'flex-start',
                justifyContent: 'center',
                display: 'flex',
              }}
          >
            {currentMatch && currentMatch.getIn(['homeTeam', 'starData', 'goals']) &&
              <MatchRowScorers
                color="black"
                weight="normal"
                size={1.5}
                scorers={currentMatch.getIn(['homeTeam', 'starData', 'goals'])}
                font="narrowRegular"
              />
            }
          </Col>
          <Col
            md={5}
            sm={3}
            xs={3}
            style={{
                padding: '0px',
                overflow: 'visible',
              }}
          />
          <Col
            md={3.5}
            sm={4.5}
            xs={4.5}
            style={{
                padding: '0px 8px 0px 0px',
                overflow: 'visible',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
              }}
          >
            {currentMatch && currentMatch.getIn(['awayTeam', 'starData', 'goals']) &&
              <MatchRowScorers
                color="black"
                weight="normal"
                size={1.5}
                scorers={currentMatch.getIn(['awayTeam', 'starData', 'goals'])}
                font="narrowRegular"
                align="right"
              />
            }
          </Col>

        </div>
      </MatchViewWrapper>
    );
  }
}

MatchViewGazzanet.propTypes = {
  currentMatch: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
  competitionId: PropTypes.any,
};

export default MatchViewGazzanet;



// WEBPACK FOOTER //
// ./src/components/MatchViewGazzanet/index.js